/*
 * /welcome (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Alert,
	ButtonLink,
	Container,
	Divider,
	Page,
	PageHeader,
} from "@emr/react-ui"
import { ArrowLeft } from "lucide-react"

export const Route = createFileRoute("/welcome")({ component: WelcomePage })

function WelcomePage() {
	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Welcome!"}
					left={{
						href: "/dashboard",
						label: "Dashboard",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<div
					className={
						"flex size-full flex-col items-center justify-center gap-3"
					}
				>
					<h4 className={"p-1 text-lg"}>
						Let's get you set up. We'll ask a few questions to personalise your
						experience to support you better.
					</h4>
					<div
						className={"flex flex-col items-center justify-center gap-3 py-6"}
					>
						<ButtonLink to={"/setup/profile"} variant={"default"}>
							Set up your profile
						</ButtonLink>
					</div>
				</div>
			</Container>
		</Page>
	)
}
